import React from 'react';
export function PropertyStats() {
  const stats = [{
    label: 'Beds',
    value: '6'
  }, {
    label: 'Baths',
    value: '5'
  }, {
    label: 'Sq Ft',
    value: '5,800'
  }, {
    label: 'Lot Size',
    value: '1.01 Acres'
  }];
  return <section className="w-full bg-cream border-b border-sand/30 py-12 md:py-16" data-id="element-74">
      <div className="max-w-6xl mx-auto px-6" data-id="element-75">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-4 divide-x-0 md:divide-x divide-sand/30" data-id="element-76">
          {stats.map((stat, index) => <div key={index} className="flex flex-col items-center text-center px-4" data-id="element-77">
              <span className="text-4xl md:text-5xl font-serif text-brown mb-2" data-id="element-78">
                {stat.value}
              </span>
              <span className="text-sm uppercase tracking-widest text-stone-deep/60" data-id="element-79">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}